import { $axios } from 'src/boot/axios'

import { Notify } from 'quasar'
import _ from 'lodash'

import { convertFEEntities, convertFEDevices, convertFEEntity, convertFEDevice } from '../../services/pethau.js'
/**
 * Typically run upon login, will fetch all the apps for a user (based on the selcted clientAccount)
 *
 * @param {*} context Vuex action context
 */
export function loadAllMyApps (context) {
  console.log('Loading Apps')
  return $axios.get('/api/v0/fe/apps').then((response) => {
    var apps = response.data

    _.each(apps, (app) => {
      app.modulesById = _.keyBy(app.modules, 'id')
    })

    context.commit('setFeApps', apps)
    return apps
  })
}

export function replaceBeApp (context, beApp) {
  context.commit('replaceBeApp', beApp)
}

/**
 *
 * @param {*} context Vuex context
 * @param {*} app a pethau frontend FEApplication holder
 */
export function selectFeApp (context, app) {
  /*
   * find app in loadedApps
   */
  let selected = null
  if (_.isString(app)) {
    selected = _.find(context.state.feApps, (feApp) => feApp.app.id === app)
  } else if (_.isObject(app)) {
    if (_.has(app, 'id')) {
      selected = _.find(context.state.feApps, (feApp) => feApp.app.id === app.id)
    } else if (_.has(app, 'app.id')) {
      selected = _.find(context.state.feApps, (feApp) => feApp.app.id === app.app.id)
    }
  }

  if (selected) {
    context.commit('setSelectedFeAppId', selected.app.id)
    return context.dispatch('loadEntities')
  } else {
    context.commit('clearSelectedFeApp')
    Notify.error('App: ' + app + ' not found')
  }
}

export function clearSelectedFeApp (context) {
  context.commit('clearSelectedFeApp')
}

export function selectModule (context, moduleId) {
  if (moduleId == null) {
    context.commit('setSelectedModule', null)
    return
  }
  var module = _(context.getters.selectedFeApp.modules).filter((m) => { return m.id === moduleId }).first()
  context.commit('setSelectedModule', module)
}

export function loadEntities (context) {
  var feApp = context.getters.selectedFeApp
  var appId = feApp.app.id
  return $axios.get('/api/v0/fe/application/' + appId + '/all').then(response => {
    var all = response.data
    context.commit('setEntities', convertFEEntities(all.entities, feApp, all.links))
    context.commit('setDevices', convertFEDevices(all.devices, feApp, all.links))
    context.commit('setLinks', all.links)
    context.commit('setNetworkAssets', all.networkAssets)
    return all
  })
}

export function replaceEntity (context, newEntity) {
  var feApp = context.getters.selectedFeApp

  // add links from original feed
  const eLinks = _(context.state.links).filter(l => l.entityId === newEntity.id).value()
  var feEntity = convertFEEntity(newEntity, feApp, eLinks)

  context.commit('updateEntity', feEntity)
}

export function replaceDevice (context, newDevice) {
  var feApp = context.getters.selectedFeApp
  var feDevice = convertFEDevice(newDevice, feApp)

  // add links from original feed
  feDevice.links = _(context.state.links).filter(l => l.deviceId === newDevice.id).value()

  context.commit('updateDevice', feDevice)
}

export function addDevice (context, newDevice) {
  var feApp = context.getters.selectedFeApp
  var feDevice = convertFEDevice(newDevice, feApp)
  feDevice.links = _(context.state.links).filter(l => l.deviceId === newDevice.id).value()
  context.commit('addDevice', feDevice)
}

export function addEntity (context, newEntity) {
  var feApp = context.getters.selectedFeApp
  const eLinks = _(context.state.links).filter(l => l.deviceId === newEntity.id).value()
  var feEntity = convertFEEntity(newEntity, feApp, eLinks)

  context.commit('addEntity', feEntity)
}

export function setEntityProperty (context, payload) {
  context.commit('setEntityProperty', payload)
}

export function addLink (context, link) {
  context.commit('addLink', link)
}

export function addNetworkAsset (context, nwa) {
  context.commit('addNetworkAsset', nwa)
}

export function replaceSelectedAppLocations (context, locations) {
  context.commit('replaceSelectedAppLocations', locations)
}
